import React, {Component} from "react";
import PropTypes from "prop-types";
import {_switchUser} from "../../../../../services/apis/AdminServices";
import getEnv from "../../../../../helpers/common/getEnv";

class SwitchUser extends Component {
    _baseAppUrl = getEnv('baseAppUrl');

    componentDidMount() {
        const {match} = this.props;
        const {userId} = match.params;

        _switchUser(userId).then(this._handleSwitchUser);
    }

    render() {
        return (
            <div className="SwitchUser">
                Loading....
            </div>
        );
    }

    _handleSwitchUser = (result) => {
        const {history} = this.props;

        const {data, success, message} = result;
        if (!success) {
            alert(message);
            return history.push('/');
        }

        const {access_token, refresh_token} = data;

        window.location.href = `${this._baseAppUrl}/oauth-callback?access_token=${access_token}&refreshToken=${refresh_token}`;
    }
}

SwitchUser.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
};

export default SwitchUser;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/switch-user/SwitchUser/SwitchUser.js